import { RemoteGetAllStudents } from 'data/usecases';
import { GetAllStudentsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlStudents } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllStudents = (): GetAllStudentsUseCaseInterface =>
  new RemoteGetAllStudents(makeApiUrlStudents(), makeAxiosHttpClient());
